export enum CheckInType {
  Draft = 1,
  Periodic,
}
export enum CurrentCheckInType {
  HalfMonth,
  Month,
  Quarter,
  Year = 4,
}
